import React from 'react'

import { EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'

import CustomizableSection from './ExecutiveSummary/CustomizableSection'

interface RenderCustomSectionsProps {
  sections: MasterCampaignPlanCustomSection[] | undefined
}

const RenderCustomSections = ({ sections }: RenderCustomSectionsProps) => {
  if (!sections || sections.length === 0) {
    return null
  }

  return (
    <>
      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <CustomizableSection section={section} defaultTitle='' defaultContent='' defaultShowTitle={true} separator='spacer' />
          <EuiSpacer size='xl' />
        </React.Fragment>
      ))}
    </>
  )
}

export default RenderCustomSections
